import { render, staticRenderFns } from "./AlertDealsComponent.vue?vue&type=template&id=6359c5ee&scoped=true&"
import script from "./AlertDealsComponent.vue?vue&type=script&lang=ts&"
export * from "./AlertDealsComponent.vue?vue&type=script&lang=ts&"
import style0 from "./AlertDealsComponent.vue?vue&type=style&index=0&id=6359c5ee&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6359c5ee",
  null
  
)

export default component.exports